import axios from "axios";
import { config } from "../configs";
import { getSessionToken } from "./getToken";
import { getUserOrgs } from "./org";

const postServiceOption = async (typeId, orgId, payload) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      await Promise.all(
        payload.map((p) =>
          axios({
            method: "POST",
            headers: {
              Authorization: jwtToken,
              Application: "Platform", 
              Organization: orgId,
            },
            url: `${config.baseURL}/servicetypes/${typeId}/serviceoptions`,
            data: p,
          })
        )
      );
      resolve(200);
    } catch (error) {
      reject(error);
    }
  });
};

const patchServiceOption = async (typeId, orgId, payload) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      await Promise.all(
        payload.map((p) =>
          axios({
            method: "PATCH",
            headers: {
              Authorization: jwtToken,
              Application: "Platform", 
              Organization: orgId,
            },
            url: `${config.baseURL}/servicetypes/${typeId}/serviceoptions/${p?.system_id}`,
            data: p,
          })
        )
      );
      resolve(200);
    } catch (error) {
      reject(error);
    }
  });
};

const getServiceOptions = async (serviceTypeId, orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/servicetypes/${serviceTypeId}/serviceoptions`;
      const response = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url,
      });
      resolve(response?.data);
    } catch (error) {
      reject(error);
    }
  });
};

const deleteServiceOption = async (serviceOptionId, serviceTypeId, orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/servicetypes/${serviceTypeId}/serviceoptions/${serviceOptionId}`;
      const { status } = await axios({
        method: "DELETE",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
      });
      resolve(status);
    } catch (error) {
      reject(error);
    }
  });
};

const createService = async (attributes, orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/servicetypes`;
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
        data: attributes,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getOrgServiceCategories = async (orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/servicecategories`;
      const { data } = await axios.get(URL, {
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getServiceTypes = async (orgs, index = 0, maintenancePlans = []) => {
  return new Promise(async function (resolve, reject) {
    try {
      if (orgs.length === 0) {
        resolve([]);
      } else {
        const jwtToken = await getSessionToken();
        const URL = `${config.baseURL}/servicetypes`;
        const { data } = await axios({
          method: "GET",
          headers: {
            Authorization: jwtToken,
            Application: "Platform", 
            Organization: orgs[index]?.id,
          },
          url: URL,
        });

        // to be done from API
        let newData = data.map((item) => ({
          ...item,
          orgId: orgs[index]?.id,
          orgName: orgs[index]?.name,
        }));
        maintenancePlans = [...maintenancePlans, ...newData];
        if (index >= Array.from(orgs).length - 1)
          return resolve(maintenancePlans);
        return resolve(
          await getServiceTypes(orgs, index + 1, maintenancePlans)
        );
      }
    } catch (error) {
      reject(error);
    }
  });
};

const getOrgServiceTypes = async () => {
  return new Promise(async function (resolve, reject) {
    try {
      let orgs = await getUserOrgs();
      let maintenancePlans = await getServiceTypes(orgs);
      resolve(maintenancePlans);
    } catch (error) {
      reject(error);
    }
  });
};

const getServiceTypesForOrg = async (orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/servicetypes`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getOrgServiceType = async (orgId, serviceId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/servicetypes/${serviceId}`;
      const { data } = await axios.get(URL, {
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const deleteService = async (orgId, serviceId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/servicetypes/${serviceId}`;
      const { data } = await axios({
        method: "DELETE",
        headers: {
          Authorization: jwtToken,
          Application: "Platform", 
          Organization: orgId,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export {
  postServiceOption,
  getServiceOptions,
  deleteServiceOption,
  getOrgServiceCategories,
  createService,
  getOrgServiceTypes,
  getOrgServiceType,
  deleteService,
  patchServiceOption,
  getServiceTypesForOrg,
};
